import { Flex, Text, TextLink } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { AsyncSignal } from '@cortex-shim/async_signal.component';
import { useResolveController } from '@visiba/instantiation';
import { FooterController } from './footer.controller';

export function AddressSection() {
	const controller = useResolveController(FooterController);

	return (
		<AsyncSignal signal={controller.data}>
			{({ addressInfo }) => (
				<>
					{addressInfo.length > 0 ? (
						<Flex gap={tokens.spacing.x0_25}>
							{addressInfo.map((field) => (
								<Text key={field.key} variant='bodyRegular'>
									{field.value}
								</Text>
							))}
						</Flex>
					) : null}
				</>
			)}
		</AsyncSignal>
	);
}
